/* eslint-disable camelcase */
import FormGroup from "legacy/FormGroup"
import ReactValidator from "legacy/ReactValidator.es6"
import MbmPricingEstimate from "legacy/boater-reservation-flow/MbmPricingEstimate"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import PromoCode from "legacy/boater-reservation-flow/PromoCode"
import buildPricingRequestPayload from "legacy/boater-reservation-flow/buildPricingRequestPayload"
import DockwaPlusOffer from "legacy/boater-reservation-flow/price-estimate/dockwa-plus-sign-up/DockwaPlusOffer"
import { SuppressionReasons } from "legacy/boater-reservation-flow/tripInsuranceConstants"
import { feetToInches, isset } from "legacy/helpers.es6"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"
import ReactOnRails from "react-on-rails"
import verticalInsureLogo from "src/assets/vi-coverage-logo.png"

import LineItems from "src/components/LineItems/LineItems"
import Modal from "src/components/Modal"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

function computeViDecision(offered, choice, record) {
  if (!offered) return record?.suppression_reason ? "suppressed" : null
  if (choice?.declined) return "declined"
  if (choice?.quoteId) return "selected"
  return null
}

class CheckoutOverview extends React.Component {
  constructor(props) {
    super(props)
    const csrfTokenElement = document.querySelector('meta[name="csrf-token"]')
    const csrfToken = csrfTokenElement
      ? csrfTokenElement.getAttribute("content")
      : ""

    this.state = {
      processing: false,
      checkbox: false,
      errorLoadingPrice: null,
      forceSubmission: false,
      emailMarketing: true,
      csrfToken,
      tripInsuranceChoice: null,
      tripInsuranceShowChoiceError: false,
      tripInsuranceLoading: false,
    }

    if (
      isset(this.props.state.userId) &&
      (!isset(this.props.state.fullName) ||
        !isset(this.props.state.phone) ||
        isset(this.props.state.missingContactInfo))
    ) {
      this.validator = new ReactValidator(["fullName", "phone", "checkbox"])
    } else {
      this.validator = new ReactValidator(["checkbox"])
    }

    this.presentmentCurrency =
      window.currentMarina?.presentmentCurrency || "USD"

    // Bind methods that use this
    this.getPriceEstimate = this.getPriceEstimate.bind(this)
    this.handleJsonResponse = this.handleJsonResponse.bind(this)
    this.fetchPriceEstimate = this.fetchPriceEstimate.bind(this)
    this.reserveSuccess = this.reserveSuccess.bind(this)
    this.requestReservation = this.requestReservation.bind(this)
    this.setSpecialRequest = this.setSpecialRequest.bind(this)
    this.nextButton = this.nextButton.bind(this)
    this.getPaymentMethod = this.getPaymentMethod.bind(this)
    this.selectedPaymentMethod = this.selectedPaymentMethod.bind(this)
    this.changePaymentMethod = this.changePaymentMethod.bind(this)
    this.marinaTAC = this.marinaTAC.bind(this)
    this.toggleCheckbox = this.toggleCheckbox.bind(this)
    this.toggleEmailMarketing = this.toggleEmailMarketing.bind(this)
    this.termsAndConditions = this.termsAndConditions.bind(this)
    this.renderEmailMarketing = this.renderEmailMarketing.bind(this)
    this.duplicateConfirmationModal = this.duplicateConfirmationModal.bind(this)
    this.closeConfirmationModal = this.closeConfirmationModal.bind(this)
    this.forceRequestReservation = this.forceRequestReservation.bind(this)
    this.getFinalSection = this.getFinalSection.bind(this)
    this.getPricingTable = this.getPricingTable.bind(this)
    this.renderPricingEstimate = this.renderPricingEstimate.bind(this)
    this.boatUS = this.boatUS.bind(this)
    this.dockwaPlusOffer = this.dockwaPlusOffer.bind(this)
    this.paymentsDueSection = this.paymentsDueSection.bind(this)
    this.pricingSection = this.pricingSection.bind(this)
    this.loadPriceTable = this.loadPriceTable.bind(this)
    this.setFullName = this.setFullName.bind(this)
    this.requireName = this.requireName.bind(this)
    this.setPhone = this.setPhone.bind(this)
    this.requirePhone = this.requirePhone.bind(this)
    this.renderVerticalInsureOffer = this.renderVerticalInsureOffer.bind(this)
    this.renderVerticalInsureOfferSkeleton =
      this.renderVerticalInsureOfferSkeleton.bind(this)
    this.handleTripInsuranceSelection =
      this.handleTripInsuranceSelection.bind(this)
    this.fetchTripInsuranceQuote = this.fetchTripInsuranceQuote.bind(this)
    this.tripInsuranceBaseCostInCents =
      this.tripInsuranceBaseCostInCents.bind(this)
    this.viEventBaseProps = this.viEventBaseProps.bind(this)
  }

  componentDidUpdate() {
    const options = this.tripInsuranceQuoteOptions()

    const choice = this.state.tripInsuranceChoice
    if (choice) {
      const choiceInvalid = !(
        choice.declined === true ||
        options.some((o) => o.quote_id === choice.quoteId)
      )
      if (choiceInvalid) {
        this.setState({
          tripInsuranceChoice: null,
          tripInsuranceShowChoiceError: false,
        })
        this.props.setGlobalState({ tripInsuranceSelection: null })
      }
    }
  }

  componentDidMount() {
    this.props.setHeader("Overview")
    this.getPriceEstimate()
    // if the user is signed in and they don't have a name or number
    if (
      isset(this.props.state.userId) &&
      (!isset(this.props.state.fullName) ||
        !isset(this.props.state.phone) ||
        isset(this.props.state.missingContactInfo))
    ) {
      this.props.setGlobalState({ missingContactInfo: true })
    }
  }

  getPriceEstimate() {
    this.props.setGlobalState({
      tripInsuranceQuote: null,
      tripInsuranceSelection: null,
    })
    this.setState({
      tripInsuranceLoading: true,
      tripInsuranceChoice: null,
      tripInsuranceShowChoiceError: false,
    })

    if (
      this.props.state.loa > 0 &&
      isset(this.props.state.arrival) &&
      isset(this.props.state.departure)
    ) {
      this.setState({ errorLoadingPrice: null })

      const postObject = buildPricingRequestPayload(this.props.state)

      const {
        useDockwaPlusPricing,
        state: { fetchV2PriceEstimate },
      } = this.props
      if (useDockwaPlusPricing) {
        fetchV2PriceEstimate()
          .then((data) => {
            const {
              marina: { mcomId: marina_id, name: marina_name },
              state: { loa, draft, arrival, departure },
            } = this.props

            const {
              pricing_summary,
              dockwa_plus_offer,
              membership,
              promo_code_id,
              discount_percentage,
              discounted_price_value,
            } = data

            const pricingSummary = pricing_summary || []
            const { amount: price_value } = pricingSummary.slice(-1).pop() || {}

            Amplitude.trackEvent("reservation_flow:checkout_price_calculated", {
              experience_name: "reservation_flow",
              marina_id,
              marina_name,
              loa: feetToInches(loa),
              draft: feetToInches(draft),
              arrival: new Date(Date.parse(arrival)),
              departure: new Date(Date.parse(departure)),
              price_value,
              promo_code_id,
              discount_percentage,
              discounted_price_value,
              membership,
              dockwa_plus_offer_promo_code_id: dockwa_plus_offer
                ? dockwa_plus_offer.promo_code_id
                : null,
              dockwa_plus_offer_discount_percentage: dockwa_plus_offer
                ? dockwa_plus_offer.discount_percentage
                : null,
              dockwa_plus_offer_discounted_price_value: dockwa_plus_offer
                ? dockwa_plus_offer.discounted_amount
                : null,
              embed_form: !!this.props.embedForm,
            })

            this.setState({ processing: false })
            this.fetchTripInsuranceQuote()
          })
          .catch((error) => {
            const {
              marina: { mcomId: marina_id, name: marina_name },
              state: { loa, draft, arrival, departure },
            } = this.props

            Amplitude.trackEvent(
              "reservation_flow:checkout_price_calculation_failed",
              {
                experience_name: "reservation_flow",
                marina_id,
                marina_name,
                loa: feetToInches(loa),
                draft: feetToInches(draft),
                arrival: new Date(Date.parse(arrival)),
                departure: new Date(Date.parse(departure)),
                error: error.message,
                embed_form: !!this.props.embedForm,
              }
            )
          })
      } else {
        this.fetchPriceEstimate(postObject).then((data) => {
          if (data) {
            this.fetchTripInsuranceQuote()
          }
        })
      }
    }
  }

  handleJsonResponse(response) {
    return response
      .json()
      .catch(() => {
        return Promise.reject(new Error("Invalid JSON response"))
      })
      .then((data) => {
        if (!response.ok) {
          const errorMessage = (data && data.error) || "Unknown error"
          return Promise.reject(new Error(errorMessage))
        }
        return data
      })
  }

  fetchPriceEstimate(postObject) {
    return fetch(this.props.priceEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.state.csrfToken,
      },
      body: JSON.stringify(postObject),
    })
      .then(this.handleJsonResponse)
      .then((data) => {
        this.props.setGlobalState({
          finalPriceEstimate: data,
          tripInsuranceQuote: null,
        })
        return data
      })
      .catch((error) => {
        this.setState({ errorLoadingPrice: error.message })
        return null
      })
  }

  reserveSuccess(data, encodedId) {
    const choice = this.state.tripInsuranceChoice
    const offered = this.tripInsuranceQuoteOptions().length > 0
    const viDecision = computeViDecision(
      offered,
      choice,
      this.tripInsuranceQuoteRecord()
    )

    const viProps = {
      ...this.viEventBaseProps(),
      vi_insurance_decision: viDecision,
    }
    if (viDecision === "selected") {
      const opt = this.tripInsuranceQuoteOptions().find(
        (o) => o.quote_id === choice.quoteId
      )
      Object.assign(viProps, {
        vi_quote_id: choice.quoteId,
        vi_coverage_type: opt?.coverage_type ?? null,
        vi_premium_amount: opt?.total ?? null,
      })
    }

    const resolvedEncodedId = encodedId ?? data?.encoded_id ?? null

    Amplitude.trackEvent("reservation_flow:reservation_requested", {
      experience_name: "reservation_flow",
      reservation_id: resolvedEncodedId,
      marina_id: this.props.marina.mcomId,
      marina_name: this.props.marina.name,
      loa: feetToInches(this.props.state.loa),
      draft: feetToInches(this.props.state.draft),
      arrival: new Date(Date.parse(this.props.state.arrival)),
      departure: new Date(Date.parse(this.props.state.departure)),
      embed_form: !!this.props.embedForm,
      ...viProps,
    })
    if (this.props.embedForm) {
      // Parse the HTML response
      const parser = new DOMParser()
      const doc = parser.parseFromString(data, "text/html")
      const newContent = doc.querySelector("#account-show-from-wl")

      // Replace the content
      const wrapper = document.querySelector("#white-label-wrapper")
      if (wrapper && newContent) {
        wrapper.innerHTML = newContent.innerHTML

        // Initialize React on Rails components in the replaced content
        const reactScripts = wrapper.querySelectorAll(
          ".js-react-on-rails-component"
        )
        reactScripts.forEach((script) => {
          const componentName = script.dataset.componentName
          const domId = script.dataset.domId

          if (componentName && domId) {
            try {
              const props = JSON.parse(script.textContent || "{}")
              ReactOnRails.render(componentName, props, domId)
            } catch (error) {
              console.error(
                `Failed to render component ${componentName}:`,
                error
              )
            }
          }
        })
      }
    } else if (data.redirect_to) {
      // Currently only used by the Android app. Future refactor should move all redirect logic to the backend controller
      window.location = data.redirect_to
    } else {
      window.location =
        process.env.BASE_URL +
        "/account/reservation-referral/" +
        data.encoded_id
    }
  }

  async requestReservation() {
    this.validator.displayErrors()
    this.setState({ validInputs: this.validator.allValid() })
    if (this.validator.allValid() === false) {
      return
    }

    const tripInsuranceOptions = this.tripInsuranceQuoteOptions()
    if (
      tripInsuranceOptions.length > 0 &&
      !this.tripInsuranceChoiceForOffer(tripInsuranceOptions)
    ) {
      this.setState({ tripInsuranceShowChoiceError: true })
      return
    }

    this.setState({ processing: true })
    const params = {
      check_in_date: this.props.state.arrival,
      check_out_date: this.props.state.departure,
      requested_space_type: this.props.state.dockType,
      special_request: this.props.state.specialRequest,
    }
    // electric
    if (isset(this.props.state.electric_id)) {
      if (this.props.state.mbm) {
        params.electric_product_id = this.props.state.electric_id
      } else {
        params.electrical_rate_id = this.props.state.electric_id
      }
    }
    // user
    if (isset(this.props.state.userId)) {
      params.user_id = this.props.state.userId
      if (isset(this.props.state.missingContactInfo)) {
        params["contact[name]"] = this.props.state.fullName
        params["contact[phone]"] = this.props.state.phone
      }
    } else {
      params["contact[name]"] = this.props.state.fullName
      params["contact[email]"] = this.props.state.email
      params["contact[phone]"] = this.props.state.phone
      params["contact[hubspot_sync]"] = this.state.emailMarketing
    }
    // boat
    if (this.props.state.boatCreated === "previously") {
      params.boat_id = this.props.state.boatId
      if (this.props.state.height)
        params["boat[height]"] = this.props.state.height * 12
      if (this.props.state.draft)
        params["boat[draw]"] = this.props.state.draft * 12
    } else {
      params["boat[make]"] = this.props.state.boatMake
      params["boat[model]"] = this.props.state.boatModel
      params["boat[name]"] = this.props.state.boatName
      params["boat[beam]"] = this.props.state.beam * 12
      params["boat[draw]"] = this.props.state.draft * 12
      if (this.props.state.height)
        params["boat[height]"] = this.props.state.height * 12
      params["boat[length_overall]"] = this.props.state.loa * 12
      params["boat[boat_type]"] = this.props.state.boatType
    }
    // stripe
    if (
      this.props.state.paymentMethodCreated === "now" &&
      isset(this.props.state.selectedPaymentMethod)
    ) {
      params.stripe_card_token =
        this.props.state.selectedPaymentMethod.stripePaymentMethodId
    } else if (
      this.props.state.paymentMethodCreated === "previously" &&
      isset(this.props.state.selectedPaymentMethod)
    ) {
      params.stripe_card_id =
        this.props.state.selectedPaymentMethod.stripePaymentMethodId
    } else {
      alert("Please add a payment method")
      return
    }
    if (this.props.state.choseBoatUS) {
      params["contact[boatus_id]"] = this.props.state.boatUSMemberID
      params["contact[boatus_zip]"] = this.props.state.boatUSZipCode
      params["contact[boatus_last_name]"] = this.props.state.boatUSLastName
    }
    if (this.props.state.verifiedBrewer) {
      params["contact[brewer_id]"] = this.props.state.brewerMemberID
      params["contact[first_name]"] = this.props.state.firstName
      params["contact[last_name]"] = this.props.state.lastName
    }
    if (isset(this.props.state.promoCode)) {
      params.promo_code_id = this.props.state.promoCode.id
    }
    if (isset(this.props.state.referralCode)) {
      params.referral_code_id = this.props.state.referralCode.id
    }
    if (tripInsuranceOptions.length > 0) {
      const ins = this.tripInsuranceChoiceForOffer(tripInsuranceOptions)
      params.trip_insurance_quote_id = ins.declined ? null : ins.quoteId
    }
    if (this.props.embedForm) {
      params.embed_form = true
    }
    if (this.state.forceSubmission) {
      params.force_submission = true
    }
    $.post(this.props.reserveEndpoint, params, (data, status, jqXHR) => {
      if (data.error) {
        this.setState({
          duplicateReservationData: data.error,
          processing: false,
        })
      } else {
        const encodedIdHeader = jqXHR?.getResponseHeader?.(
          "X-Reservation-Encoded-Id"
        )
        this.reserveSuccess(data, encodedIdHeader)
      }
    }).fail((error) => {
      switch (error.status) {
        case 402:
          // Payment required
          BootstrapDialog.alert({
            type: BootstrapDialog.TYPE_DANGER,
            title: "Payment Method Declined",
            message:
              'It looks like your payment method was declined. Please select another payment method and try again.<br /><br /><span class="text-danger">' +
              JSON.parse(error.responseText).error +
              "</span>",
          })
          this.nextButton()
          break
        case 409:
          // Duplicate account error
          BootstrapDialog.alert({
            type: BootstrapDialog.TYPE_DANGER,
            title: "Error Requesting Reservation",
            message: error.responseJSON.error,
          })
          break
        case 500:
          if (error.responseJSON.reservation_persisted) {
            this.reserveSuccess(error.responseJSON.reservation)
          } else {
            BootstrapDialog.alert({
              type: BootstrapDialog.TYPE_DANGER,
              title: "Error Requesting Reservation",
              message:
                "Looks like something went wrong, please try again or contact Dockwa Support at mayday@dockwa.com",
            })
          }
          break
        default:
          // Any other type of error throw an alert
          BootstrapDialog.alert({
            type: BootstrapDialog.TYPE_DANGER,
            title: "Error Requesting Reservation",
            message:
              "Looks like something went wrong, please try again or contact Dockwa Support at mayday@dockwa.com",
          })
      }
      this.setState({ processing: false })
    })
  }

  handleTripInsuranceSelection(selection) {
    this.setState({
      tripInsuranceChoice: selection,
      tripInsuranceShowChoiceError: false,
    })
    this.props.setGlobalState({ tripInsuranceSelection: selection })

    const base = this.viEventBaseProps()
    if (selection.declined) {
      Amplitude.trackEvent(
        this.props.tripInsuranceAmplitudeEvents.PRODUCT_DECLINED,
        base
      )
    } else {
      const opt = this.tripInsuranceQuoteOptions().find(
        (o) => o.quote_id === selection.quoteId
      )
      Amplitude.trackEvent(
        this.props.tripInsuranceAmplitudeEvents.PRODUCT_SELECTED,
        {
          ...base,
          vi_quote_id: selection.quoteId,
          vi_coverage_type: opt?.coverage_type ?? null,
          vi_premium_amount: opt?.total ?? null,
        }
      )
    }
  }

  tripInsuranceChoiceForOffer(options) {
    const choice = this.state.tripInsuranceChoice
    if (
      choice &&
      (choice.declined === true ||
        options.some((o) => o.quote_id === choice.quoteId))
    ) {
      return choice
    }
    return null
  }

  tripInsuranceBaseCostInCents(
    { dockType, pricingBreakdown, finalPriceEstimate } = {
      dockType: this.props.state.dockType,
      pricingBreakdown: this.props.state.pricingBreakdown,
      finalPriceEstimate: this.props.state.finalPriceEstimate,
    }
  ) {
    const { useDockwaPlusPricing } = this.props

    if (useDockwaPlusPricing) {
      const totalFromBreakdown = pricingBreakdown?.slice(-1)?.[0]?.amount
      return Number.isFinite(totalFromBreakdown) ? totalFromBreakdown : 0
    }

    if (finalPriceEstimate?.mbm?.totalPrice != null) {
      return finalPriceEstimate.mbm.totalPrice
    }

    if (finalPriceEstimate?.[dockType]?.total != null) {
      return finalPriceEstimate[dockType].total
    }

    return 0
  }

  fetchTripInsuranceQuote() {
    const payload = buildPricingRequestPayload(this.props.state)

    if (!payload.check_in_date || !payload.check_out_date) {
      this.props.setGlobalState({ tripInsuranceQuote: null })
      this.setState({ tripInsuranceLoading: false })
      return Promise.resolve(null)
    }

    this.props.setGlobalState({ tripInsuranceQuote: null })
    this.setState({ tripInsuranceLoading: true })

    return fetch(this.props.tripInsuranceQuoteEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.state.csrfToken,
      },
      body: JSON.stringify(payload),
    })
      .then(this.handleJsonResponse)
      .then((data) => {
        this.props.setGlobalState({
          tripInsuranceQuote: data,
        })
        this.setState({ tripInsuranceLoading: false })

        if (data?.options?.length > 0) {
          Amplitude.trackEvent(
            this.props.tripInsuranceAmplitudeEvents.OFFER_VIEWED,
            this.viEventBaseProps(data)
          )
        } else if (data?.suppression_reason) {
          Amplitude.trackEvent(
            this.props.tripInsuranceAmplitudeEvents.OFFER_SUPPRESSED,
            {
              ...this.viEventBaseProps(data),
              suppression_reason: data.suppression_reason,
              suppression_message: data.suppression_message ?? null,
            }
          )
        }
        return data
      })
      .catch(() => {
        this.props.setGlobalState({ tripInsuranceQuote: null })
        this.setState({ tripInsuranceLoading: false })
        Amplitude.trackEvent(
          this.props.tripInsuranceAmplitudeEvents.OFFER_SUPPRESSED,
          {
            ...this.viEventBaseProps(null),
            suppression_reason: SuppressionReasons.LOAD_FAILURE,
          }
        )
        return null
      })
  }

  tripInsuranceQuoteRecord() {
    return this.props.state.tripInsuranceQuote || null
  }

  tripInsuranceQuoteOptions() {
    return this.tripInsuranceQuoteRecord()?.options || []
  }

  viEventBaseProps(quoteOverride) {
    const quote =
      quoteOverride !== undefined
        ? quoteOverride
        : this.tripInsuranceQuoteRecord()
    const tp = quote?.options?.find((o) => o.coverage_type === "COMPREHENSIVE")
    const cfar = quote?.options?.find(
      (o) => o.coverage_type === "COMPREHENSIVE_CFAR"
    )
    return {
      marina_id: this.props.marina.mcomId,
      marina_name: this.props.marina.name,
      booking_total: this.tripInsuranceBaseCostInCents(),
      trip_installment_type: quote?.installment_type ?? null,
      trip_upfront_cost: quote?.upfront_cost ?? null,
      vi_offer_id: quote?.offer_id ?? null,
      vi_quoted_premium_trip_protection: tp?.total ?? null,
      vi_quoted_premium_cfar: cfar?.total ?? null,
    }
  }

  renderVerticalInsureOfferSkeleton() {
    const skeletonRowClass =
      "h-3 animate-pulse rounded bg-gray-200/80 dark:bg-gray-300"

    return (
      <div
        className="rounded border p-4"
        style={{ backgroundColor: "#fff8f1", borderColor: "#f2cfab" }}
        key="vertical-insure-skeleton"
        aria-busy="true"
        aria-live="polite"
      >
        <div className="space-y-3">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="rounded border p-3"
              style={{ backgroundColor: "#fffdfb", borderColor: "#f2cfab" }}
            >
              <div className="flex items-start gap-3">
                <div className="mt-1 h-4 w-4 shrink-0 animate-pulse rounded-full bg-gray-200" />
                <div className="min-w-0 flex-1 space-y-2">
                  <div className="flex items-center justify-between gap-3">
                    <div className={`${skeletonRowClass} w-1/2`} />
                    <div className={`${skeletonRowClass} w-16`} />
                  </div>
                  <div className={`${skeletonRowClass} w-11/12`} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  renderVerticalInsureOffer() {
    if (this.state.tripInsuranceLoading) {
      return this.renderVerticalInsureOfferSkeleton()
    }
    const options = this.tripInsuranceQuoteOptions()
    if (!options.length) return null
    const choice = this.tripInsuranceChoiceForOffer(options)
    const legalDisclaimer = options[0]?.product?.legal_disclaimer?.replace(
      /<a /g,
      '<a target="_blank" rel="noopener noreferrer" '
    )

    return (
      <div
        className="rounded border p-4"
        style={{ backgroundColor: "#fff8f1", borderColor: "#f2cfab" }}
        key="vertical-insure"
      >
        <h4 className="mt-0 text-lg font-semibold text-gray-900">
          Protect Your Trip
        </h4>
        <p className="mb-3 text-sm text-gray-600">
          Add protection to your{" "}
          {formatCurrencyFromMinorUnits({
            amount: this.tripInsuranceBaseCostInCents(),
            currency: this.presentmentCurrency,
          })}{" "}
          reservation.
        </p>
        <div className="space-y-3">
          {options.map((option) => {
            const radioChecked =
              !!choice && !choice.declined && choice.quoteId === option.quote_id
            const showPerils =
              radioChecked &&
              option.product?.perils &&
              option.product.perils.length > 0
            const showDescriptors =
              radioChecked &&
              option.product?.descriptors &&
              option.product.descriptors.length > 0

            return (
              <label
                key={option.quote_id}
                className="block cursor-pointer rounded border p-3"
                style={{
                  backgroundColor: "#fffdfb",
                  borderColor: radioChecked ? "#fb923c" : "#f2cfab",
                }}
              >
                <div className="flex items-start gap-3">
                  <input
                    type="radio"
                    name="trip-insurance-selection"
                    className="mt-1"
                    checked={radioChecked}
                    onChange={() => {
                      this.handleTripInsuranceSelection({
                        quoteId: option.quote_id,
                        declined: false,
                      })
                    }}
                    aria-label={`Select ${option.product?.promotional_header}`}
                  />
                  <div className="min-w-0 flex-1">
                    <div className="flex w-full min-w-0 items-start justify-between gap-3">
                      <span className="min-w-0 flex-1 text-sm font-semibold text-gray-900">
                        {option.product?.promotional_header}
                      </span>
                      <span className="shrink-0 text-right text-sm font-semibold tabular-nums text-gray-900">
                        {formatCurrencyFromMinorUnits({
                          amount: option.total,
                          currency: this.presentmentCurrency,
                        })}
                      </span>
                    </div>
                    {option.product?.promotional_description ? (
                      <div
                        className="trip-insurance-promo-desc mb-0 mt-1 text-sm text-gray-600 [&_a]:underline"
                        dangerouslySetInnerHTML={{
                          __html: option.product.promotional_description,
                        }}
                      />
                    ) : null}
                    {showPerils ? (
                      <div className="mt-3 border-t border-gray-200 pt-3">
                        <div className="text-xs font-semibold text-gray-900">
                          {option.product?.peril_heading || "What's Covered"}
                        </div>
                        <ul className="mb-0 mt-2 list-none space-y-1.5 pl-0">
                          {option.product.perils.map((peril) => (
                            <li
                              key={peril}
                              className="flex items-start gap-1.5 text-xs text-gray-700"
                            >
                              <i
                                className="icon icon-check mt-0.5 shrink-0 text-xs text-teal-600"
                                aria-hidden
                              />
                              <span>{peril}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : null}
                    {showDescriptors
                      ? option.product.descriptors.map((descriptor) => (
                          <div
                            className="mt-2"
                            key={`descriptor-${descriptor}`}
                          >
                            <div
                              className="trip-insurance-legal-disclaimer mt-1 text-xs text-gray-600 [&_a]:underline"
                              dangerouslySetInnerHTML={{
                                __html: descriptor.replace(
                                  /<a /g,
                                  '<a target="_blank" rel="noopener noreferrer" '
                                ),
                              }}
                            />
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </label>
            )
          })}
          <label
            className="block cursor-pointer rounded border p-3"
            style={{
              backgroundColor: "#fffdfb",
              borderColor: choice?.declined ? "#fb923c" : "#f2cfab",
            }}
          >
            <div className="flex items-center gap-3">
              <input
                type="radio"
                name="trip-insurance-selection"
                checked={choice?.declined === true}
                onChange={() => {
                  this.handleTripInsuranceSelection({
                    quoteId: null,
                    declined: true,
                  })
                }}
                aria-label="No, do not protect my trip"
              />
              <div className="text-sm font-semibold text-gray-900">
                No, do not protect my trip
              </div>
            </div>
          </label>
        </div>
        {this.state.tripInsuranceShowChoiceError ? (
          <div className="form-error-message">
            Please choose trip protection or select that you do not want
            coverage.
          </div>
        ) : null}
        <div className="mt-3 flex items-center gap-2 text-sm text-gray-600">
          <span>Offered by</span>
          <img
            src={verticalInsureLogo}
            alt="Vi Coverage by Vertical Insure"
            className="h-7 w-auto"
          />
        </div>
        {legalDisclaimer ? (
          <div className="mt-2">
            <div
              className="trip-insurance-legal-disclaimer mt-1 text-xs text-gray-600 [&_a]:underline"
              dangerouslySetInnerHTML={{ __html: legalDisclaimer }}
            />
          </div>
        ) : null}
      </div>
    )
  }

  setSpecialRequest(event) {
    this.props.setGlobalState({ specialRequest: event.target.value })
  }

  nextButton() {
    this.props.routeTo("next")
  }

  getPaymentMethod() {
    const {
      selectedPaymentMethod: { title },
    } = this.props.state

    return <div className="flex">{title}</div>
  }

  selectedPaymentMethod() {
    if (!isset(this.props.state.selectedPaymentMethod)) {
      return (
        <button
          type="button"
          className="btn btn-secondary"
          onClick={this.nextButton}
        >
          Add Payment Method
        </button>
      )
    } else {
      return this.getPaymentMethod()
    }
  }

  changePaymentMethod() {
    if (isset(this.props.state.selectedPaymentMethod)) {
      return (
        <button
          type="button"
          className="text-muted ml-2 bg-transparent p-0 text-sm"
          onClick={this.nextButton}
        >
          change
        </button>
      )
    } else {
      return (
        <i
          className="icon icon-question-circle form-control-icon-right cursor-pointer"
          data-container="body"
          data-toggle="popover"
          data-placement="top"
          style={{ fontSize: ".8em", marginLeft: "7px", color: "#B7B7B7" }}
          data-content="You are about to make a reservation request. Your payment method is NOT charged unless the reservation is confirmed by the marina."
        />
      )
    }
  }

  marinaTAC() {
    if (isset(this.props.state.marinaTAC)) {
      return (
        <span>
          &nbsp;and&nbsp;
          <a
            href={
              process.env.BASE_URL +
              "/home/terms_and_conditions/" +
              this.props.state.marinaID
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Conditions
          </a>
        </span>
      )
    }
  }

  toggleCheckbox(e) {
    this.setState({ checkbox: !this.state.checkbox })
  }

  toggleEmailMarketing(event) {
    this.setState({ emailMarketing: event.target.checked })
  }

  termsAndConditions() {
    return (
      <div className="my-3">
        <div className="checkbox">
          <label style={{ fontWeight: 500 }}>
            <input
              type="checkbox"
              onChange={this.toggleCheckbox}
              checked={this.state.checkbox}
            />
            I agree to {this.props.state.marinaName}&#8217;s&nbsp;
            <a
              href={
                process.env.BASE_URL +
                "/home/cancellation_policies/" +
                this.props.state.marinaCP
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              Cancellation Policy
            </a>
            {this.marinaTAC()}
            &nbsp;and Dockwa&#8217;s&nbsp;
            <a
              href={process.env.BASE_URL + "/about-us/terms-of-service"}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms and Conditions
            </a>{" "}
            and{" "}
            <a
              href={process.env.BASE_URL + "/privacy"}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            .
          </label>
        </div>
        {this.validator.message(
          "checkbox",
          this.state.checkbox,
          "required_checkbox"
        )}
      </div>
    )
  }

  renderEmailMarketing() {
    if (!this.props.state.whiteLabel && !isset(this.props.state.userId)) {
      return (
        <div>
          <FormGroup
            name="email_marketing"
            label="Join Dockwa's community for the latest news and updates."
            labelClassName="font-normal pl-1"
            inputType="checkbox"
            value={this.state.emailMarketing}
            onChange={this.toggleEmailMarketing}
            className="mb-4 mt-0 flex cursor-pointer pl-4"
          />
        </div>
      )
    }
  }

  duplicateConfirmationModal() {
    if (this.state.duplicateReservationData) {
      const data = this.state.duplicateReservationData
      return (
        <Modal isOpen={true} onClose={this.closeConfirmationModal} size="small">
          <Modal.Header title="Duplicate Reservations Found" />
          <Modal.Body>
            <p>
              We found existing reservations for your boat{" "}
              <b>{data.boatName}</b> at <b>{data.marinaName}</b> from{" "}
              <b>{data.startDate}</b> to <b>{data.endDate}</b>
            </p>
            <p>
              {data.duplicateReservationEncodedIds.map((id) => {
                return (
                  <a
                    key={id}
                    target="_blank"
                    href={"/account/reservations/" + id}
                    className="list-group-item list-group-item-action"
                    rel="noreferrer"
                  >
                    Reservation: {id}
                  </a>
                )
              })}
            </p>
            <p>
              Are you sure you want to submit a duplicate reservation request?
            </p>
          </Modal.Body>
          <Modal.Footer
            confirmBtnText="Confirm Duplicate Reservation"
            confirmBtnLoading={this.state.processing}
            cancelBtnText="Cancel"
            onSubmit={this.forceRequestReservation}
            onClose={this.closeConfirmationModal}
          />
        </Modal>
      )
    }
  }

  closeConfirmationModal() {
    this.setState({
      duplicateReservationData: undefined,
    })
  }

  forceRequestReservation() {
    this.setState(
      {
        forceSubmission: true,
      },
      this.requestReservation
    )
    this.closeConfirmationModal()
  }

  getFinalSection() {
    const { processing } = this.state
    const { fetchV2PriceLoading, fetchV2PriceError } = this.props.state

    if (isset(this.props.state.selectedPaymentMethod)) {
      return (
        <div>
          {this.termsAndConditions()}
          {this.renderEmailMarketing()}
          <NextButton
            id="checkoutOverviewContinueButton"
            btnClass="btn-primary"
            processing={processing || fetchV2PriceLoading}
            disabled={isset(fetchV2PriceError)}
            click={this.requestReservation}
            icon="icon-circle-check"
            text="Request Reservation"
            processingText="Requesting..."
          />
          <div className="text-muted mt-3">
            Your reservation is NOT confirmed until{" "}
            {this.props.state.marinaName} accepts it.{" "}
            {this.props.state.marinaName} usually responds in{" "}
            {this.props.last4WeekAvgPendingResTime}.
          </div>
        </div>
      )
    } else {
      return (
        <button
          id="checkoutOverviewAddPaymentMethodButton"
          type="button"
          className="btn btn-primary"
          onClick={this.nextButton}
        >
          Add Payment Method
        </button>
      )
    }
  }

  getPricingTable() {
    const rows = []
    const pricing =
      this.props.state.finalPriceEstimate[this.props.state.dockType].breakdown
    Object.keys(pricing).forEach((key) => {
      const total = formatCurrencyFromMinorUnits({
        amount: pricing[key],
        currency: this.presentmentCurrency,
      })
      const isDockageOrMoorage = ["Dockage", "Moorage"].includes(key)
      const showMinNightReq =
        this.props.state.minNightRequirement && isDockageOrMoorage

      rows.push(
        <tr key={key}>
          <td>
            <span className={`block ${key === "Discount" && "text-red-600"}`}>
              {key}
            </span>
            {showMinNightReq && (
              <span className="text-xs text-gray-600">{`Price reflects a ${this.props.state.minNightRequirement}-night minimum`}</span>
            )}
          </td>
          <td className="right">
            <span className={`block ${key === "Discount" && "text-red-600"}`}>
              ({total})
            </span>
            {showMinNightReq && <span className="invisible">-</span>}
          </td>
        </tr>
      )
    })
    return rows
  }

  renderPricingEstimate() {
    return (
      <div>
        <h3 className="text-lg">Pricing</h3>
        <table className="my-4 table border border-t-0">
          <tbody>
            <tr className="sr-only">
              <th>Item</th>
              <th>Price</th>
            </tr>
            {this.getPricingTable()}
            <tr>
              <td className="bg-gray-200 text-lg font-semibold">You Pay</td>
              <td
                id="finalPriceTotal"
                className="right bg-gray-200 text-lg font-semibold"
              >
                {formatCurrencyFromMinorUnits({
                  amount:
                    this.props.state.finalPriceEstimate[
                      this.props.state.dockType
                    ].total,
                  currency: this.presentmentCurrency,
                })}
              </td>
            </tr>
          </tbody>
        </table>
        <p className="font-semibold text-teal-700">
          <i className="icon icon-credit-card mr-3" />
          {
            this.props.state.finalPriceEstimate[this.props.state.dockType]
              .billing_display_text
          }
        </p>
      </div>
    )
  }

  boatUS() {
    if (this.props.state.choseBoatUS) {
      return (
        <div>
          <div className="row">
            <div className="col-sm-12">
              <h4 className="text-left">BoatUS Membership</h4>
              <div id="reservationBoatUSInformation" className="text-left">
                {this.props.state.boatUSLastName},{" "}
                {this.props.state.boatUSMemberID}
              </div>
            </div>
          </div>
          <hr className="my-3.5" />
        </div>
      )
    }
  }

  dockwaPlusOffer() {
    const {
      state: {
        user: { id: userId },
        dockwaPlusOffer,
        fetchV2PriceLoading,
        loadingDockwaPlusProductInformation,
      },
      openDockwaPlusModal,
    } = this.props

    return dockwaPlusOffer && !fetchV2PriceLoading ? (
      <DockwaPlusOffer
        dockwaPlusOffer={dockwaPlusOffer}
        userId={userId}
        handleOpenModal={openDockwaPlusModal}
        loadingProductInformation={loadingDockwaPlusProductInformation}
      />
    ) : null
  }

  paymentsDueSection() {
    const {
      useDockwaPlusPricing,
      state: { fetchV2PriceLoading, paymentsDue },
    } = this.props

    return useDockwaPlusPricing && paymentsDue && paymentsDue.length > 0 ? (
      <div className="rounded bg-gray-100 p-4" key={"payments-due"}>
        <h4 className="mt-0 font-semibold">Payments Due</h4>
        <LineItems
          lineItems={paymentsDue}
          loading={fetchV2PriceLoading}
          loadingItems={1}
          currency={this.presentmentCurrency}
        />
      </div>
    ) : null
  }

  pricingSection() {
    const {
      state: { pricingBreakdown, fetchV2PriceLoading },
    } = this.props

    return (
      <div className="rounded bg-gray-100 p-4" key={"pricing"}>
        <h4 className="mt-0 font-semibold">Pricing</h4>
        <LineItems
          lineItems={pricingBreakdown}
          loading={fetchV2PriceLoading}
          currency={this.presentmentCurrency}
        />
      </div>
    )
  }

  loadPriceTable() {
    const {
      useDockwaPlusPricing,
      state: { fetchV2PriceError },
    } = this.props

    if (useDockwaPlusPricing) {
      return fetchV2PriceError ? (
        <div className="rounded bg-gray-100 p-4">
          <h4 className="mt-0 font-semibold">Pricing</h4>
          <div className="card mb-4 text-center">
            <p>An error occurred while loading the price.</p>
            <p>Error: {fetchV2PriceError}</p>
          </div>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={this.getPriceEstimate}
          >
            Retry
          </button>
        </div>
      ) : (
        [
          this.pricingSection(),
          this.paymentsDueSection(),
          this.dockwaPlusOffer(),
        ]
      )
    }

    if (isset(this.state.errorLoadingPrice)) {
      return (
        <div id="reservationErrorLoadingPrice">
          <h3 className="text-lg">Pricing</h3>
          <div className="card mb-4 text-center">
            <p>An error occurred while loading the price.</p>
            <p>Error: {this.state.errorLoadingPrice}</p>
          </div>
        </div>
      )
    } else if (isset(this.props.state.finalPriceEstimate)) {
      if (this.props.state.finalPriceEstimate.mbm) {
        const {
          chargeBreakdown,
          creditBreakdown,
          tax,
          totalPrice,
          paymentsDue,
        } = this.props.state.finalPriceEstimate.mbm

        return (
          <MbmPricingEstimate
            loadingPrice={false}
            chargeBreakdown={chargeBreakdown}
            creditBreakdown={creditBreakdown}
            tax={tax}
            totalPrice={totalPrice}
            paymentsDue={paymentsDue}
            priceErrorMessage={this.state.errorLoadingPrice}
          />
        )
      } else {
        return this.renderPricingEstimate()
      }
    } else {
      // RETURN LOADING INDICATOR
      return (
        <div>
          <h3 className="text-lg">Pricing</h3>
          <div id="checkoutPriceLoading" className="text-center">
            <i
              className="icon icon-spinner icon-spin my-3"
              style={{ fontSize: "4rem", color: "#eef2f4" }}
            />
          </div>
        </div>
      )
    }
  }

  setFullName(event) {
    this.props.setGlobalState({ fullName: event.target.value })
  }

  requireName() {
    if (
      isset(this.props.state.userId) &&
      isset(this.props.state.missingContactInfo)
    ) {
      return (
        <div className="form-group">
          <label>Full name</label>
          <div className="form-control-with-icon">
            <i className="icon icon-user-male form-control-icon-left" />
            <input
              id="checkoutOverviewFullName"
              className="form-control"
              value={this.props.state.fullName}
              onChange={this.setFullName}
            />
            {this.validator.message(
              "fullName",
              this.props.state.fullName,
              "required"
            )}
          </div>
        </div>
      )
    }
  }

  setPhone(event) {
    this.props.setGlobalState({ phone: event.target.value })
  }

  requirePhone() {
    if (
      isset(this.props.state.userId) &&
      isset(this.props.state.missingContactInfo)
    ) {
      return (
        <div className="form-group">
          <label>Phone</label>
          <div className="form-control-with-icon">
            <i className="icon icon-phone-btm form-control-icon-left" />
            <input
              id="checkoutOverviewPhone"
              className="form-control"
              value={this.props.state.phone}
              onChange={this.setPhone}
            />
            {this.validator.message(
              "phone",
              this.props.state.phone,
              "required"
            )}
          </div>
        </div>
      )
    }
  }

  render() {
    const { useDockwaPlusPricing } = this.props

    return (
      <div id="checkoutOverview" className="checkout-overview">
        {this.state.duplicateReservationData &&
          this.duplicateConfirmationModal()}
        <div className="row">
          <div className="col-xs-6">
            <h3 className="text-center text-lg">Arrival</h3>
            <p id="reservationArrival" className="text-center text-base">
              {moment(this.props.state.arrival, "L").format(
                "ddd, MMM DD, YYYY"
              )}
            </p>
          </div>
          <div className="col-xs-6">
            <h3 className="text-center text-lg">Departure</h3>
            <p id="reservationDeparture" className="text-center text-base">
              {moment(this.props.state.departure, "L").format(
                "ddd, MMM DD, YYYY"
              )}
            </p>
          </div>
        </div>
        <hr className="my-3.5" />
        <div className="row">
          <div className="col-xs-8">
            <h4 className="text-left text-base">Boat</h4>
            <p id="reservationBoatDisplayText" className="text-left">
              {this.props.state.boatDisplayText}
            </p>
          </div>
          <div className="col-xs-4">
            <h4 className="text-right text-base">Space Type</h4>
            <p id="reservationSpaceType" className="text-right">
              {this.props.state.dockType}
            </p>
          </div>
        </div>
        <hr className="my-3.5" />
        <div className="row">
          <div className="col-xs-8">
            <h4 className="text-left text-base">
              Payment Method {this.changePaymentMethod()}
            </h4>
            <div id="reservationPaymentMethod" className="text-left">
              {this.selectedPaymentMethod()}
            </div>
          </div>
          <div className="col-xs-4">
            <h4 className="text-right text-base">Boater</h4>
            <p id="reservationBoaterName" className="text-right">
              {this.props.state.fullName}
            </p>
          </div>
        </div>
        <hr className="my-3.5" />
        {this.boatUS()}
        <div className="flex flex-col gap-4">
          {this.loadPriceTable()}
          {this.requireName()}
          {this.requirePhone()}
          <PromoCode
            setGlobalState={this.props.setGlobalState}
            reloadPricing={this.getPriceEstimate}
            promoCode={this.props.state.promoCode}
            referralCode={this.props.state.referralCode}
            email={this.props.state.email}
            userId={this.props.state.userId}
            marinaSlug={this.props.state.marinaSlug}
            useDockwaPlusPricing={useDockwaPlusPricing}
          />
          {this.renderVerticalInsureOffer()}
        </div>
        <hr className="my-3.5" />
        <div className="form-group">
          <label htmlFor="specialRequest">Special Requests</label>
          <textarea
            className="form-control"
            id="specialRequest"
            value={this.props.state.specialRequest}
            onChange={this.setSpecialRequest}
            placeholder="e.g. Cruising with a group, Yacht Club affiliation, Docking preference…"
          />
        </div>
        {this.getFinalSection()}
      </div>
    )
  }
}

CheckoutOverview.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setGlobalState: PropTypes.func.isRequired,
  routeTo: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired,
  priceEndpoint: PropTypes.string.isRequired,
  priceV2Endpoint: PropTypes.string,
  tripInsuranceQuoteEndpoint: PropTypes.string.isRequired,
  tripInsuranceAmplitudeEvents: PropTypes.objectOf(PropTypes.string).isRequired,
  tripInsuranceSuppressionReasons: PropTypes.objectOf(PropTypes.string)
    .isRequired,
  reserveEndpoint: PropTypes.string.isRequired,
  useDockwaPlusPricing: PropTypes.bool,
  last4WeekAvgPendingResTime: PropTypes.string,
  marina: PropTypes.object.isRequired,
  openDockwaPlusModal: PropTypes.func,
  embedForm: PropTypes.bool,
}

export default CheckoutOverview
